import {
  ExternalRouteRef,
  RouteRef,
  SubRouteRef,
  createExternalRouteRef,
  createSubRouteRef,
} from '@backstage/core-plugin-api';

import { createPageRoute } from '@spotify/confidence-common-react';

export enum RoutesIds {
  recordings = 'recordings',
  recording = 'recordings-recording',
  recordingFinding = 'recordings-recording-finding',
  recordingEmbed = 'recordings-recording-embed',
  explorer = 'recordings-explorer',
  insights = 'recordings-insights',
  settings = 'recordings-settings',
  targetingPolicy = 'recordings-targeting-policy',
}

export const rootRouteRef = createPageRoute({
  id: RoutesIds.recordings,
  page: { title: 'Recordings' },
});

export const recordingRouteRef = createSubRouteRef({
  id: RoutesIds.recording,
  parent: rootRouteRef,
  path: '/:id',
});

export const recordingFindingRouteRef = createSubRouteRef({
  id: RoutesIds.recordingFinding,
  parent: rootRouteRef,
  path: '/:id/findings/:findingId',
});

export const recordingEmbedRouteRef = createSubRouteRef({
  id: RoutesIds.recordingEmbed,
  parent: rootRouteRef,
  path: '/:id/embed',
});

export const explorerRouteRef = createSubRouteRef({
  id: RoutesIds.explorer,
  parent: rootRouteRef,
  path: '/explorer',
});

export const insightsRouteRef = createPageRoute({
  id: RoutesIds.insights,
  route: { parent: rootRouteRef, path: '/insights' },
  page: { title: 'Recording insights' },
});

export const settingsRouteRef = createSubRouteRef({
  id: RoutesIds.settings,
  parent: rootRouteRef,
  path: '/settings',
});

export const targetingPolicyRouteRef = createSubRouteRef({
  id: RoutesIds.targetingPolicy,
  parent: rootRouteRef,
  path: '/settings/:policyId',
});

export const Routes = {
  [RoutesIds.recordings]: rootRouteRef,
  [RoutesIds.recording]: recordingRouteRef,
  [RoutesIds.recordingFinding]: recordingFindingRouteRef,
  [RoutesIds.recordingEmbed]: recordingEmbedRouteRef,
  [RoutesIds.explorer]: explorerRouteRef,
  [RoutesIds.insights]: insightsRouteRef,
  [RoutesIds.settings]: settingsRouteRef,
  [RoutesIds.targetingPolicy]: targetingPolicyRouteRef,
} satisfies Record<RoutesIds, SubRouteRef | RouteRef>;

enum ExternalRoutesIds {
  agentContext = 'agentContext',
}

export const agentContextRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.agentContext,
  optional: true,
});

export const ExternalRoutes = {
  agentContext: agentContextRouteRef,
} satisfies Record<ExternalRoutesIds, ExternalRouteRef>;
